export default __webpack_public_path__ + "static/media/integration-confirmation.ee6a5d27.png";